import { render, staticRenderFns } from "./vorgang-table.vue?vue&type=template&id=60349db8&scoped=true"
import script from "./vorgang-table.vue?vue&type=script&lang=js"
export * from "./vorgang-table.vue?vue&type=script&lang=js"
import style0 from "./vorgang-table.vue?vue&type=style&index=0&id=60349db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60349db8",
  null
  
)

export default component.exports